const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
function pad(num) {
    return num.toString().padStart(2, '0');
}
export function getCampaignCountdownUnits(targetTimestamp) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const diff = Math.max(targetTimestamp - now, 0);
    const days = Math.floor(diff / DAY);
    const hours = Math.floor(diff % DAY / HOUR);
    const minutes = Math.floor(diff % HOUR / MINUTE);
    return {
        isEnded: diff <= 0,
        units: [
            {
                label: intl.get('login.campaign.countdown.days'),
                value: pad(days)
            },
            {
                label: intl.get('login.campaign.countdown.hours'),
                value: pad(hours)
            },
            {
                label: intl.get('login.campaign.countdown.minutes'),
                value: pad(minutes)
            }
        ]
    };
}
